import React from 'react';
import RemoveIcon from '@material-ui/icons/Remove';
export const MinusSquare = props => {
  return (
    <RemoveIcon fontSize="inherit" {...props} />
  );
}
